import { render, staticRenderFns } from "./automated-tasks.vue?vue&type=template&id=bb2cb2ac&scoped=true"
import script from "./automated-tasks.vue?vue&type=script&lang=js"
export * from "./automated-tasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2cb2ac",
  null
  
)

export default component.exports